module.exports = __webpack_public_path__ + "static/media/whiteChat.9982c359.svg";